module.exports = __webpack_public_path__ + "eb3403aec691f36856946452c5f470af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/toast.png
// module id = 2755
// module chunks = 0